// Footer.jsx — add id="site-footer" to the outer div
import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import bgImage from "../../assets/images/blue.jpg";

const Footer = () => {
  return (
    <div id="site-footer" className="relative bg-gradient-to-t from-black via-transparent to-black">
      <img
        src={bgImage}
        alt=""
        aria-hidden="true"
        loading="lazy"
        decoding="async"
        fetchpriority="low"
        className="absolute top-0 left-0 w-full h-full object-cover opacity-80 -z-10 pointer-events-none"
      />

      <footer className="flex flex-col items-center justify-center py-24 relative overflow-hidden">
        <div className="flex flex-col lg:flex-row justify-evenly items-center w-full px-4 lg:px-20 pb-36 gap-20">
          <h1 className="text-white font-poppins uppercase text-center text-[60px] sm:text-[120px] lg:text-[220px] font-semibold leading-[1.2]">
            Talk <br />
            <span className="italic font-playfair text-[80px] sm:text-[140px] lg:text-[180px]">
              to us.
            </span>
          </h1>

          <div className="max-w-[700px] flex flex-col items-start text-left">
            <p className="text-white font-poppins text-[18px] font-light leading-6 tracking-wider mb-10">
              Let us know what you're looking for, and we'll provide a
              personalized quote that matches your goals and budget. Wondering
              about the cost?
            </p>
            <Link to="https://wa.me/+201555339569">
              <button className="bg-[#76cfff] text-black rounded-full px-12 py-4 text-[16px] leading-6 cursor-pointer">
                Contact us
              </button>
            </Link>
          </div>
        </div>

        <span className="w-full h-px bg-black"></span>

        <div className="flex flex-col lg:flex-row justify-evenly items-center w-full px-4 lg:px-20 py-10 gap-12 text-center lg:text-left">
          <div className="w-[300px] lg:w-[400px]">
            <img
              src={logo}
              alt="Luster Photobooth logo"
              loading="lazy"
              decoding="async"
              fetchpriority="low"
              width={400}
              height={400}
              className="w-full h-auto"
            />
          </div>

          <div className="flex flex-col items-center lg:items-start">
            <h2 className="text-white font-playfair italic text-[30px] sm:text-[40px] lg:text-[60px] font-semibold mb-4">
              Let's talk
            </h2>
            <p className="text-white font-poppins text-[14px] sm:text-[16px] lg:text-[18px] font-light tracking-widest">
              Lusterphotobooth@gmail.com
            </p>
            <p className="text-white font-poppins text-[14px] sm:text-[16px] lg:text-[18px] font-light tracking-widest">
              +201555339569
            </p>
          </div>

          <div className="flex flex-col items-center lg:items-start gap-4">
            <Link
              to="https://www.instagram.com/luster_photobooth/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white font-poppins text-[14px] sm:text-[16px] lg:text-[18px] font-light tracking-widest"
            >
              Instagram
            </Link>
            <Link
              to="https://www.facebook.com/profile.php?id=100064348793272&mibextid=ZbWKwL"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white font-poppins text-[14px] sm:text-[16px] lg:text-[18px] font-light tracking-widest"
            >
              Facebook
            </Link>
            <Link
              to="https://wa.me/+201555339569"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white font-poppins text-[14px] sm:text-[16px] lg:text-[18px] font-light tracking-widest"
            >
              Whatsapp
            </Link>
          </div>

          <div className="text-white font-poppins text-[14px] sm:text-[16px] lg:text-[18px] font-light tracking-widest">
            <p>©2025 Luster.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;